export enum Steps {
  CART,
  TRAVELERS_INFORMATION,
  BILLING_INFORMATION,
  PAYMENT,
}